import Axios from "axios";

export default {
    ObtenerEstados(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Busqueda/ObtenerEstado`).then(response => response.data);
    },
    ObtenerReportesVial(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Vial/ObtenerReportesVial`, data).then(response => response.data);
    },
    ObtenerReportesVialRegistros(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Vial/ObtenerReportesVialRegistros`, data).then(response => response.data);
    }
}